import { h } from 'preact';
import { icon } from '@fortawesome/fontawesome-svg-core'
import { useEffect, useRef } from 'preact/hooks';
import RubricReport from './rubric-report';
import FeedbackContainer from './feedback-container';
const minus = icon({prefix: "fas", iconName: "minus"});
const times = icon({prefix: "fas", iconName: "times"});
const check = icon({prefix: "fas", iconName: "check"})

/**
 *  @typedef {import("../../shared-types").QuestionComponentProps} Props
 */
/**
 *  @typedef {import("../../shared-types").StudentResponse} StudentResponse
 */

/**
 *
 * @param {Props} props
 */
export default function (props) {
  /**
   * @type import("preact").RefObject.<HTMLDivElement>
   */
  let containerRef = useRef();
  useEffect(() => {
    if(!containerRef.current) {
      return
    }

    let container = containerRef.current

    if(props.scoringData && (Array.isArray(props.scoringData) || !('inputs' in props.scoringData))) {
      throw new Error("Scoring data must be an object");
    }
    let scoringData = props.scoringData;

    /**
     * @type Object.<string, import("../../shared-types").FillInTheBlankInputScoringData>
     */
    let scoringDataByInputId = (scoringData?.inputs || []).reduce((obj, sd) => {
      obj[sd.id] = sd;
      return obj;
    }, {})

    let scoringMode = props.item.correctResponse?.scoring_mode || "teacher_scored";

    let hidePoints = props.hidePoints || scoringMode == "all_or_nothing" || scoringMode == "teacher_scored";

    (props.item.responseDeclaration.inputs || []).forEach((inputDef) => {
      let sd = scoringDataByInputId[inputDef.id]
      let response = (props.studentResponse?.fill_in_the_blank?.input_responses || []).find((r) => r.input_id == String(inputDef.id))
      let input = container.querySelector("input[data-gap-identifier=\"" + inputDef.id + "\"]");
      if(input && input instanceof HTMLInputElement) {
        let span = document.createElement("div")
        span.classList.add("fill-in-the-blank-report-response");
        let icon = "";
        let points = ""
        if(sd) {
          let outcome = "";
          if(sd.correct) {
            outcome = "correct";
          } else if(sd.points > 0) {
            outcome = "partial"
          } else {
            outcome = "incorrect"
          }


          if(outcome == "correct") {
            icon = check.html.join()
          } else if(outcome == "incorrect" || outcome == "omit") {
            icon = times.html.join();
          } else if(outcome == "partial") {
            icon = minus.html.join();
          }
          if(!hidePoints) {
            points = `<span class='score'>${outcome == "correct" || outcome == "partial" ? sd.points : 0}</span>`
          }
          span.classList.add(outcome);
        }
        span.innerHTML = (response?.text || "") +"<br/>"+(props.hideAllAnswers || scoringMode == "teacher_scored" ? "" : icon)+points
        input.replaceWith(span)
      }
    })
  }, [])

  return <>
    <div class="question-wrapper">
      <div class="fill-in-the-blank-report-container question-body" ref={containerRef} dangerouslySetInnerHTML={{__html: props.item.bodyWithSubstitutions || ""}}>
      </div>
    </div>
    {props.teacherResponse?.text_feedback ? <FeedbackContainer feedbackText={props.teacherResponse.text_feedback} /> : null}
    {props.rubricReport ? <RubricReport rubricReport={props.rubricReport}/>: null}
  </>
}